export default {
      id: "ic_doc_ecouter-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_doc_ecouter-usage",
      toString: function () {
        return this.url;
      }
    }